import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { ACLService } from '@delon/acl'
import { _HttpClient, SettingsService } from '@delon/theme'
import { environment } from '@env/environment'
const { msUrl } = environment.api
import { map, zip } from 'rxjs'

@Component({
  selector: 'header-swap',
  template: `
    <div *ngIf="show" nz-dropdown [nzDropdownMenu]="tenantMenu" nzPlacement="bottomRight">
      <span style="margin-right: 5px">{{ company }}</span>
      <i nz-icon nzType="swap"></i>
    </div>
    <nz-dropdown-menu #tenantMenu="nzDropdownMenu">
      <ul nz-menu>
        <li
          nz-menu-item
          *ngFor="let item of tenants"
          [nzSelected]="item.tenantId === currentTenant"
          (click)="change(item.tenantId)"
        >
          {{ item.name }}
        </li>
      </ul>
    </nz-dropdown-menu>
  `,
})
export class HeaderSwapComponent implements OnInit {
  tenants: any = []
  currentTenant: any = ''
  show = true
  company: any = ''

  constructor(
    private http: _HttpClient,
    private router: Router,
    private settingService: SettingsService,
    private aclService: ACLService,
  ) {}

  ngOnInit(): void {
    this.initTenants()
  }

  initTenants(): void {
    const user$ = this.http.get(`${msUrl.auth}/users/info`)
    const tenants$ = this.http.get(`${msUrl.auth}/tenants/user/tenants`)

    zip(user$, tenants$)
      .pipe(map(([user, tenants]) => ({ user, tenants })))
      .subscribe(({ user, tenants }) => {
        const { currentTenant } = user.data
        this.currentTenant = currentTenant
        this.tenants = tenants.data
        //this.show = tenants.data.length > 1
        this.company = this.tenants.find((item: any) => item.tenantId == currentTenant)?.name
        this.settingService.setUser(user.data)

        if (sessionStorage.getItem('from.swapping.action') == '1') {
          sessionStorage.removeItem('from.swapping.action')
          const { permissions = [] } = user.data
          this.aclService.set({ role: [...(permissions ?? []), 'exception'] })
        }
      })
  }

  change(tenantId: string): void {
    this.http.put(`${msUrl.auth}/tenants/${tenantId}/switch?save=false`).subscribe((res: any) => {
      if (res.successful) {
        sessionStorage.setItem('from.swapping.action', '1')
        this.router.navigateByUrl('/')
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
    })
  }
}
